import type { ReactNode } from 'react';
import { useCanAccessSettingsSection } from '@/hooks/useMemberAccess';
import type { SettingsSectionId } from '@finvox/shared/member-access';

export function SettingsSectionGuard({
  sectionId,
  children
}: {
  sectionId: SettingsSectionId;
  children: ReactNode;
}) {
  const allowed = useCanAccessSettingsSection(sectionId);
  if (!allowed) return null;
  return children;
}
